import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
function BusinessCcrReportSuccess(props) {
  return (
    <Container fluid>
      <Image src={require('./success.svg')} />
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center d-flex flex-column'>
          <span className='popup-title-bold'> הבקשה הועברה בהצלחה. </span>
          <span className='popup-title'> המידע ישלח למייל {props.mail} ב 24 שעות הקרובות. </span>
        </Row>
      </div>

      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            props.setIsShowPopup(false);
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
}

export default BusinessCcrReportSuccess;
